// Email verification required screen translations for all 11 supported languages

export const emailVerificationTranslations = {
  pt: {
    title: "Verifique o seu email",
    subtitle: "Enviámos um link de verificação para o seu endereço de email",
    sent_to: "Enviado para",
    instruction_1:
      "Clique no link de verificação no email que lhe enviámos para ativar a sua conta MoneyLights.",
    instruction_2:
      "O link de verificação é válido por 24 horas. Se não o receber, pode solicitar um novo abaixo.",
    resend_button: "Reenviar email de verificação",
    resending: "A reenviar...",
    resend_success: "Email de verificação reenviado com sucesso! Verifique a sua caixa de entrada.",
    resend_count: "Email reenviado {{count}} vez(es)",
    resend_cooldown: "Aguarde {{seconds}}s antes de reenviar",
    sign_out: "Terminar sessão",
    tips_title: "Não recebeu o email?",
    tip_1: "Verifique a pasta de spam ou lixo eletrónico",
    tip_2: "Confirme que introduziu o email correto",
    tip_3: "Aguarde alguns minutos - por vezes os emails demoram a chegar",
    help_text: "Ainda com problemas?",
    contact_support: "Contacte o suporte",
    footer_security: "Este passo garante a segurança da sua conta e dados financeiros.",
  },
  en: {
    title: "Check your email",
    subtitle: "We've sent a verification link to your email address",
    sent_to: "Sent to",
    instruction_1:
      "Click on the verification link in the email we sent you to activate your MoneyLights account.",
    instruction_2:
      "The verification link is valid for 24 hours. If you don't receive it, you can request a new one below.",
    resend_button: "Resend verification email",
    resending: "Resending...",
    resend_success: "Verification email resent successfully! Check your inbox.",
    resend_count: "Email resent {{count}} time(s)",
    resend_cooldown: "Wait {{seconds}}s before resending",
    sign_out: "Sign out",
    tips_title: "Didn't receive the email?",
    tip_1: "Check your spam or junk folder",
    tip_2: "Confirm you entered the correct email address",
    tip_3: "Wait a few minutes - emails can sometimes be delayed",
    help_text: "Still having trouble?",
    contact_support: "Contact support",
    footer_security: "This step ensures the security of your account and financial data.",
  },
  es: {
    title: "Revisa tu correo electrónico",
    subtitle: "Hemos enviado un enlace de verificación a tu dirección de correo",
    sent_to: "Enviado a",
    instruction_1:
      "Haz clic en el enlace de verificación del correo que te enviamos para activar tu cuenta de MoneyLights.",
    instruction_2:
      "El enlace de verificación es válido durante 24 horas. Si no lo recibes, puedes solicitar uno nuevo abajo.",
    resend_button: "Reenviar correo de verificación",
    resending: "Reenviando...",
    resend_success: "¡Correo de verificación reenviado con éxito! Revisa tu bandeja de entrada.",
    resend_count: "Correo reenviado {{count}} vez(ces)",
    resend_cooldown: "Espera {{seconds}}s antes de reenviar",
    sign_out: "Cerrar sesión",
    tips_title: "¿No recibiste el correo?",
    tip_1: "Revisa tu carpeta de spam o correo no deseado",
    tip_2: "Confirma que introdujiste el correo correcto",
    tip_3: "Espera unos minutos - a veces los correos tardan en llegar",
    help_text: "¿Sigues teniendo problemas?",
    contact_support: "Contacta con soporte",
    footer_security: "Este paso garantiza la seguridad de tu cuenta y datos financieros.",
  },
  fr: {
    title: "Vérifiez votre email",
    subtitle: "Nous avons envoyé un lien de vérification à votre adresse email",
    sent_to: "Envoyé à",
    instruction_1:
      "Cliquez sur le lien de vérification dans l'email que nous vous avons envoyé pour activer votre compte MoneyLights.",
    instruction_2:
      "Le lien de vérification est valable 24 heures. Si vous ne le recevez pas, vous pouvez en demander un nouveau ci-dessous.",
    resend_button: "Renvoyer l'email de vérification",
    resending: "Renvoi en cours...",
    resend_success: "Email de vérification renvoyé avec succès! Vérifiez votre boîte de réception.",
    resend_count: "Email renvoyé {{count}} fois",
    resend_cooldown: "Attendez {{seconds}}s avant de renvoyer",
    sign_out: "Se déconnecter",
    tips_title: "Vous n'avez pas reçu l'email?",
    tip_1: "Vérifiez votre dossier spam ou courrier indésirable",
    tip_2: "Confirmez que vous avez entré la bonne adresse email",
    tip_3: "Attendez quelques minutes - les emails peuvent parfois être retardés",
    help_text: "Toujours des problèmes?",
    contact_support: "Contacter le support",
    footer_security: "Cette étape garantit la sécurité de votre compte et de vos données financières.",
  },
  de: {
    title: "Überprüfen Sie Ihre E-Mail",
    subtitle: "Wir haben einen Bestätigungslink an Ihre E-Mail-Adresse gesendet",
    sent_to: "Gesendet an",
    instruction_1:
      "Klicken Sie auf den Bestätigungslink in der E-Mail, die wir Ihnen gesendet haben, um Ihr MoneyLights-Konto zu aktivieren.",
    instruction_2:
      "Der Bestätigungslink ist 24 Stunden gültig. Wenn Sie ihn nicht erhalten, können Sie unten einen neuen anfordern.",
    resend_button: "Bestätigungs-E-Mail erneut senden",
    resending: "Wird erneut gesendet...",
    resend_success: "Bestätigungs-E-Mail erfolgreich erneut gesendet! Überprüfen Sie Ihren Posteingang.",
    resend_count: "E-Mail {{count}} Mal erneut gesendet",
    resend_cooldown: "Warten Sie {{seconds}}s vor erneutem Senden",
    sign_out: "Abmelden",
    tips_title: "E-Mail nicht erhalten?",
    tip_1: "Überprüfen Sie Ihren Spam- oder Junk-Ordner",
    tip_2: "Bestätigen Sie, dass Sie die richtige E-Mail-Adresse eingegeben haben",
    tip_3: "Warten Sie einige Minuten - E-Mails können manchmal verzögert sein",
    help_text: "Immer noch Probleme?",
    contact_support: "Support kontaktieren",
    footer_security: "Dieser Schritt gewährleistet die Sicherheit Ihres Kontos und Ihrer Finanzdaten.",
  },
  it: {
    title: "Controlla la tua email",
    subtitle: "Abbiamo inviato un link di verifica al tuo indirizzo email",
    sent_to: "Inviato a",
    instruction_1:
      "Clicca sul link di verifica nell'email che ti abbiamo inviato per attivare il tuo account MoneyLights.",
    instruction_2:
      "Il link di verifica è valido per 24 ore. Se non lo ricevi, puoi richiederne uno nuovo qui sotto.",
    resend_button: "Reinvia email di verifica",
    resending: "Reinvio in corso...",
    resend_success: "Email di verifica reinviata con successo! Controlla la tua casella di posta.",
    resend_count: "Email reinviata {{count}} volt(e)",
    resend_cooldown: "Attendi {{seconds}}s prima di reinviare",
    sign_out: "Disconnetti",
    tips_title: "Non hai ricevuto l'email?",
    tip_1: "Controlla la cartella spam o posta indesiderata",
    tip_2: "Conferma di aver inserito l'indirizzo email corretto",
    tip_3: "Attendi qualche minuto - le email possono a volte essere ritardate",
    help_text: "Hai ancora problemi?",
    contact_support: "Contatta il supporto",
    footer_security: "Questo passaggio garantisce la sicurezza del tuo account e dei tuoi dati finanziari.",
  },
  nl: {
    title: "Controleer uw e-mail",
    subtitle: "We hebben een verificatielink naar uw e-mailadres gestuurd",
    sent_to: "Verzonden naar",
    instruction_1:
      "Klik op de verificatielink in de e-mail die we u hebben gestuurd om uw MoneyLights-account te activeren.",
    instruction_2:
      "De verificatielink is 24 uur geldig. Als u deze niet ontvangt, kunt u hieronder een nieuwe aanvragen.",
    resend_button: "Verificatie-e-mail opnieuw verzenden",
    resending: "Opnieuw verzenden...",
    resend_success: "Verificatie-e-mail succesvol opnieuw verzonden! Controleer uw inbox.",
    resend_count: "E-mail {{count}} keer opnieuw verzonden",
    resend_cooldown: "Wacht {{seconds}}s voordat u opnieuw verzendt",
    sign_out: "Uitloggen",
    tips_title: "E-mail niet ontvangen?",
    tip_1: "Controleer uw spam- of ongewenste e-mailmap",
    tip_2: "Bevestig dat u het juiste e-mailadres heeft ingevoerd",
    tip_3: "Wacht een paar minuten - e-mails kunnen soms vertraagd zijn",
    help_text: "Nog steeds problemen?",
    contact_support: "Neem contact op met support",
    footer_security: "Deze stap waarborgt de beveiliging van uw account en financiële gegevens.",
  },
  da: {
    title: "Tjek din e-mail",
    subtitle: "Vi har sendt et bekræftelseslink til din e-mailadresse",
    sent_to: "Sendt til",
    instruction_1:
      "Klik på bekræftelseslinket i den e-mail, vi har sendt dig, for at aktivere din MoneyLights-konto.",
    instruction_2:
      "Bekræftelseslinket er gyldigt i 24 timer. Hvis du ikke modtager det, kan du anmode om et nyt nedenfor.",
    resend_button: "Gensend bekræftelses-e-mail",
    resending: "Gensender...",
    resend_success: "Bekræftelses-e-mail gensendt med succes! Tjek din indbakke.",
    resend_count: "E-mail gensendt {{count}} gang(e)",
    resend_cooldown: "Vent {{seconds}}s før gensendelse",
    sign_out: "Log ud",
    tips_title: "Modtog du ikke e-mailen?",
    tip_1: "Tjek din spam- eller uønsket post-mappe",
    tip_2: "Bekræft at du har indtastet den korrekte e-mailadresse",
    tip_3: "Vent et par minutter - e-mails kan nogle gange være forsinket",
    help_text: "Har du stadig problemer?",
    contact_support: "Kontakt support",
    footer_security: "Dette trin sikrer sikkerheden af din konto og dine finansielle data.",
  },
  sv: {
    title: "Kontrollera din e-post",
    subtitle: "Vi har skickat en verifieringslänk till din e-postadress",
    sent_to: "Skickat till",
    instruction_1:
      "Klicka på verifieringslänken i e-postmeddelandet vi skickade till dig för att aktivera ditt MoneyLights-konto.",
    instruction_2:
      "Verifieringslänken är giltig i 24 timmar. Om du inte får den kan du begära en ny nedan.",
    resend_button: "Skicka verifierings-e-post igen",
    resending: "Skickar igen...",
    resend_success: "Verifierings-e-post skickad igen! Kontrollera din inkorg.",
    resend_count: "E-post skickad igen {{count}} gång(er)",
    resend_cooldown: "Vänta {{seconds}}s innan du skickar igen",
    sign_out: "Logga ut",
    tips_title: "Fick du inte e-postmeddelandet?",
    tip_1: "Kontrollera din skräppost- eller skräpmapp",
    tip_2: "Bekräfta att du angav rätt e-postadress",
    tip_3: "Vänta några minuter - e-postmeddelanden kan ibland vara försenade",
    help_text: "Har du fortfarande problem?",
    contact_support: "Kontakta support",
    footer_security: "Detta steg säkerställer säkerheten för ditt konto och dina finansiella data.",
  },
  fi: {
    title: "Tarkista sähköpostisi",
    subtitle: "Olemme lähettäneet vahvistuslinkin sähköpostiosoitteeseesi",
    sent_to: "Lähetetty osoitteeseen",
    instruction_1: "Napsauta sähköpostiviestissä olevaa vahvistuslinkkiä aktivoidaksesi MoneyLights-tilisi.",
    instruction_2:
      "Vahvistuslinkki on voimassa 24 tuntia. Jos et saa sitä, voit pyytää uuden alla.",
    resend_button: "Lähetä vahvistussähköposti uudelleen",
    resending: "Lähetetään uudelleen...",
    resend_success: "Vahvistussähköposti lähetetty uudelleen onnistuneesti! Tarkista postilaatikkosi.",
    resend_count: "Sähköposti lähetetty uudelleen {{count}} kerta(a)",
    resend_cooldown: "Odota {{seconds}}s ennen uudelleen lähettämistä",
    sign_out: "Kirjaudu ulos",
    tips_title: "Etkö saanut sähköpostia?",
    tip_1: "Tarkista roskapostikansiosi",
    tip_2: "Varmista, että annoit oikean sähköpostiosoitteen",
    tip_3: "Odota muutama minuutti - sähköpostit voivat joskus viivästyä",
    help_text: "Onko sinulla edelleen ongelmia?",
    contact_support: "Ota yhteyttä tukeen",
    footer_security: "Tämä vaihe varmistaa tilisi ja taloustietojesi turvallisuuden.",
  },
  et: {
    title: "Kontrolli oma e-posti",
    subtitle: "Oleme saatnud kinnituslingi sinu e-posti aadressile",
    sent_to: "Saadetud aadressile",
    instruction_1:
      "Klõpsa kinnituslingil e-kirjas, mille me sulle saatsime, et aktiveerida oma MoneyLightsi konto.",
    instruction_2: "Kinnituslink kehtib 24 tundi. Kui sa seda ei saa, võid allpool taotleda uue.",
    resend_button: "Saada kinnituskiri uuesti",
    resending: "Saatmine uuesti...",
    resend_success: "Kinnituskiri saadetud edukalt uuesti! Kontrolli oma postkasti.",
    resend_count: "E-kiri saadetud uuesti {{count}} kord(a)",
    resend_cooldown: "Oota {{seconds}}s enne uuesti saatmist",
    sign_out: "Logi välja",
    tips_title: "Ei saanud e-kirja?",
    tip_1: "Kontrolli oma rämpsposti kausta",
    tip_2: "Kinnita, et sisestasid õige e-posti aadressi",
    tip_3: "Oota mõni minut - e-kirjad võivad mõnikord hilineda",
    help_text: "Kas sul on endiselt probleeme?",
    contact_support: "Võta ühendust toega",
    footer_security: "See samm tagab sinu konto ja finantsteabe turvalisuse.",
  },
};
